import { LANGUAGES, normalizeLanguage } from './languages';
import { localizedRentalOptions, localizedTours } from './localizedTours';
import { translations } from './translations';

// The single integration point for a language. New locales are registered here
// after adding their route definition, UI catalog, tours, and rental options.
export function getLocalePack(language = 'en') {
  const code = normalizeLanguage(language);

  return {
    ...LANGUAGES[code],
    code,
    ui: translations[code] || translations.en,
    fallbackUi: translations.en,
    tours: localizedTours[code] || {},
    rentalOptions: localizedRentalOptions[code] || {},
  };
}

export function getLocaleUi(language = 'en') {
  return getLocalePack(language).ui;
}
